
/* Export */
export let lsService = window.localStorage;



// WEBPACK FOOTER //
// ./src/services/localStorage.service.js